export const ORGANIC_SIGN_UP_TOTAL_STEPS = 3;
export const TOKENIZED_SIGN_UP_TOTAL_STEPS = 4;
export const SIGN_UP_ACTIVATION_STEP = 1;

export const getSignUpFlowProgressValue = (
  step: number,
  totalSteps: number
): number => {
  const value = Math.min((step * 100) / totalSteps, 100);
  return Math.floor(value * 100) / 100;
};

export const getOrganicSetupProfileDisplayStep = (
  internalStep: number
): number => internalStep + SIGN_UP_ACTIVATION_STEP;
